import React, { useEffect } from 'react';
import { useHistory } from '@useHistory/useHistoryCompat';
import { CREATE_ACTIVATION_CACHE_KEY } from '../constants/constants';
import { TRACKER_CREATE_ACTIVATION_INIT } from '../tracking';
import { RbacPermissions } from '../../../core/interfaces/user';
import { HdWizardStepTree } from '../../../wizard/wizard-native/interface';
import { HdResolvedComponent } from '../../../routing/components/resolved-component/HdResolvedComponent';
import { useWizard } from '../../../wizard/hooks/useWizard';
import { WizardSteps } from '../../../wizard/components/wizard-steps/WizardSteps';
import useAnalyticsTracker from '../../../analytics/hooks/useAnalyticsTracker';
import useHasPermission from '../../../access-control/hooks/useHasPermission';
import { useActivationStateMachine } from './useActivationStateMachine';
import { WizardHeader } from '@hevoio/hevo-ui-toolkit';

const stepGroups: HdWizardStepTree = {
  for: '',
  id: 'create-activation',
  title: 'Create Activation',
  children: [
    {
      id: 'connect-warehouse',
      title: 'Select Warehouse',
      for: 'connect-warehouse',
      children: []
    },
    {
      id: 'connect-target',
      title: 'Select Target',
      for: 'connect-target',
      children: []
    },
    {
      id: 'write-query',
      title: 'Write your Query',
      for: 'write-query',
      children: []
    },
    {
      id: 'map-fields',
      title: 'Map Fields',
      for: 'map-fields',
      children: []
    }
  ]
};

export function CreateActivation() {
  const { hasPermission } = useHasPermission();
  const history = useHistory();

  return (
    <HdResolvedComponent
      Component={CreateActivationInner}
      canActivate={[
        () => {
          if (hasPermission(RbacPermissions.ACTIVATION_CREATE)) {
            return true;
          }

          history.replace('/activation');
          return false;
        }
      ]}
    />
  );
}

function CreateActivationInner() {
  const history = useHistory();
  const stateMachine = useActivationStateMachine();
  const { eventTrack } = useAnalyticsTracker();

  const onComplete = () => {
    history.push('/activation');
  };

  const {
    wizardState,
    createWizard,
    stepTracker,
    controller,
    currentStep,
    stepTreeSnapshot,
    selectStepGroup
  } = useWizard({
    onComplete
  });

  const onCancelClick = () => {
    history.push('/activation');
  };

  const onBackClick = () => {
    if (stepTracker.getCurrentStep().path === 'write-query/select-target-object') {
      controller.selectStep('connect-target/select-target');
    } else if (stepTracker.getCurrentStep().path === 'connect-target/select-target') {
      controller.selectStep('connect-warehouse/select-warehouse');
    } else {
      controller.goBack();
    }
  };

  useEffect(() => {
    eventTrack({
      action: TRACKER_CREATE_ACTIVATION_INIT
    });

    createWizard({
      options: {
        trackingOptions: {
          storageKey: CREATE_ACTIVATION_CACHE_KEY
        }
      },
      stateMachine
    });
  }, []);

  return (
    <div className='main-content-area'>
      <WizardHeader
        withNavigationControls
        steps={stepGroups}
        stepTreeSnapshot={stepTreeSnapshot}
        back={onBackClick}
        close={onCancelClick}
        Left={() => <span className='text-subheading-2 text-ellipsis'>Create Activation</span>}
        selectStepGroup={index => selectStepGroup(stepGroups, index)}
      />

      <div className='flex-1 overflow-hidden'>
        <WizardSteps
          wizardState={wizardState}
          currentStep={currentStep}
          LoadingComponent={stateMachine.loadingComp}
        />
      </div>
    </div>
  );
}
